import '~/js/modules/common';
import '~/pug/blocks/plainform/plain-form.js';
import ImageFullscreen from '~/js/modules/image-fullscreen';
import getSwiperSlider from '~/js/modules/slider';
import Swiper from 'swiper';
import Vue from 'vue'
import show from '~/pug/blocks/plainform/show.js'
import projectform from '~/pug/blocks/plainform/projectform.vue'
let getFormId = (selector) => parseInt(document.querySelector(selector).dataset.formId)

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.js-project-reviews');
  if (!el) return false;

  const parent = el.closest('.project-components-page__reviews');
  const dots = Array.from(parent.querySelectorAll('.js-project-reviews-dots button'));
  const prevBtn = parent.querySelector('.js-project-reviews-prev');
  const nextBtn = parent.querySelector('.js-project-reviews-next');

  const slider = new Swiper(el, {
    speed: 600,
  });

  const onChange = () => {
    dots.forEach((dot, i) => {
      dot.classList[i === slider.realIndex ? 'add' : 'remove']('project-reviews__dot--active');
    });

    if (prevBtn) {
      prevBtn.classList[slider.isBeginning ? 'add' : 'remove']('project-reviews__btn--faded');
    }

    if (nextBtn) {
      nextBtn.classList[slider.isEnd ? 'add' : 'remove']('project-reviews__btn--faded');
    }
  };

  onChange();
  slider.on('slideChange', onChange);

  // Dots
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      slider.slideTo(i + 1);
    });
  });

  if (prevBtn)
    prevBtn.addEventListener('click', () => {
      slider.slidePrev();
    });

  if (nextBtn)
    nextBtn.addEventListener('click', () => {
      slider.slideNext();
    });
});

if (document.querySelectorAll('.project-form-js').length) {
  const modal = new Vue({
    el: '.project-form-js',
    components: {
      projectform
    }
  });

  show(getFormId('.project-form-js'))
}
